var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16 6.72667C10.6 11.66 8 15.78 8 18.9133C8 23.7533 11.5333 27.18 16 27.18C20.4667 27.18 24 23.7533 24 18.9133C24 15.78 21.4 11.6467 16 6.72667ZM16.3733 25.82C13.5333 25.9933 10.2133 24.3667 9.45333 20.3267C9.40913 20.065 9.47069 19.7965 9.62447 19.5802C9.77825 19.3639 10.0117 19.2175 10.2733 19.1733C10.535 19.1291 10.8035 19.1907 11.0198 19.3445C11.2361 19.4983 11.3825 19.7317 11.4267 19.9933C11.9733 22.9667 14.4667 23.9667 16.28 23.82C16.8533 23.7933 17.3333 24.2467 17.3333 24.82C17.3333 25.3533 16.9067 25.7933 16.3733 25.82Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.16667C8.89337 9.23334 5.33337 14.4733 5.33337 18.9C5.33337 25.54 10.4 29.8333 16 29.8333C21.6 29.8333 26.6667 25.54 26.6667 18.9C26.6667 14.4733 23.1067 9.23334 16 3.16667ZM16 27.1667C11.5334 27.1667 8.00004 23.74 8.00004 18.9C8.00004 15.78 10.6 11.6467 16 6.71334C21.4 11.6467 24 15.7667 24 18.9C24 23.74 20.4667 27.1667 16 27.1667ZM10.44 19.1667C10.9334 19.1667 11.3334 19.5133 11.4267 19.9933C11.9734 22.9533 14.4667 23.9667 16.28 23.82C16.8534 23.7933 17.3334 24.2467 17.3334 24.82C17.3334 25.3533 16.9067 25.7933 16.3734 25.82C13.5334 25.9933 10.2134 24.3667 9.45337 20.3267C9.4302 20.1837 9.43836 20.0374 9.47727 19.8979C9.51619 19.7585 9.58494 19.6291 9.67877 19.5188C9.7726 19.4085 9.88926 19.3198 10.0207 19.259C10.1521 19.1983 10.2952 19.1667 10.44 19.1667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.ce9f1a0c7c758bd76574977ca41c0a51.svg";
export { ForwardRef as ReactComponent };